import React from 'react'
import MaterialSymbol from '../material-symbol'

const FileDownload = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="file_download" {...props} />
))

FileDownload.displayName = 'FileDownload'

export default FileDownload
